import React, {Component} from 'react';
import {message} from 'antd';
import {updateSlide} from "../../../redux_actions/maps.state.action";
import EditableTagGroup from '../../viewer/viewer.tags';
import cookie from "react-cookies";

import '../../../asset/style/neoviewer/slide_info.css';
import {Loader, slideViewerType} from '../../../utils/const';
import {getPrefixedUrl, getSlideLocalPath, isSuperuser, notNull, openInNewTab} from '../../../utils/utils';
import {
	Divider,
	Grid,
	Input,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	TextField
} from "@mui/material";
import {connect} from "react-redux";
import {ModeEditOutlined, SaveOutlined} from "@mui/icons-material";
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import {get_response} from "../../../helper/request";
import {LoadingText} from "../components/components";

class SlideInfoApp extends Component {
	constructor(props){
		super(props);
		this.state = this.initState();
		this.editFields = this.editFields.bind(this)
		this.saveFields = this.saveFields.bind(this)
		this.onChangeCaseDetails = this.onChangeCaseDetails.bind(this)
		this.onChangeName = this.onChangeName.bind(this)
		this.onChangeSpecimenType = this.saveFields.bind(this)
		this.is_superuser = isSuperuser()
	}

	initState = () => ({
		edit: false,
		name: this.props.slide?.name,
		specimen_type: this.props.slide?.specimen_type,
		case_details: (this.props.slide?.case_details === null ||
			this.props.slide?.case_details === "") ? "NIL" : this.props.slide?.case_details,
		slide_details: this.props.slide?.slide_details,
	});

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.slide !== this.props.slide)
			this.setState(this.initState());
	}

	editFields() {
		this.setState({
			edit: true,
			tagedit: true
		})
	}


	saveFields() {
		let slideData = {};

		if (this.state.name !== this.props.slide.name) {
			slideData.name = this.state.name;
		}

		if (this.state.slide_details !== this.props.slide.slide_details) {
			slideData.slide_details = this.state.slide_details;
		}

		if (Object.keys(slideData).length > 0) {
			this.props.dispatch(updateSlide(this.props.activeMapId, this.props.slide.id, slideData));
		}
		
		this.setState({
			edit: false,
			tagedit: false
		});
	}

	onChangeName(e){
		this.setState({
			name : e.target.value
		})
	}

	onChangeSpecimenType(e){
		this.setState({
			specimen_type : e.target.value
		})
	}

	onChangeCaseDetails(e){
		this.setState({
			case_details : e.target.value
		})
	}

	redoStitching = () => {
		get_response('/server/redo_stitching/?morphle_id=' + this.props.slide.morphle_id)
			.then(() => {
				message.success("Scheduled slide for Stitching")
			})
			.catch(() => {
				message.error("Could not schedule slide for Stitching")
			})
	}

	changeSlideDetails = (event) => {
		this.setState({
			slide_details: event.target.value
		});
	}



	render() {
		if (this.props.loadingState.loading) {
			return <Loader/>
		}
		if (!this.props.slide) return <LoadingText/>;

		const createTableRow = (key, value) =>
			<TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
				<TableCell component={"th"} scope={"row"}>{key}</TableCell>
				<TableCell align={"right"}>{value}</TableCell>
			</TableRow>;

		let slide_info_card = [
			hasPermissions([aclPermissions.view_slide_details]) && notNull(this.props.slide?.meta) && (
				<Grid container key="slide-info-details">
					<Grid item xs={12}>
						<Divider style={{margin: "10px"}} />
						<h4 style={{color: 'white', textAlign : 'center', margin: "5px"}}>Scan Details</h4>
					</Grid>
					<Grid item xs={12}>
						<TableContainer component={Paper}>
							<Table>
								<TableBody>
									{this.props.slide.exposure ?
										createTableRow("Exposure", this.props.slide.exposure) :
										undefined
									}{this.props.slide.gamma ?
										createTableRow("Gamma", this.props.slide.gamma) :
										undefined
									}
									{this.props.slide.meta?.scan_speed ?
										createTableRow("Scan Speed", this.props.slide.meta.scan_speed) :
										undefined
									}
									{hasPermissions([aclPermissions.view_slide_details]) ? [
										createTableRow("Scan Time", this.props.slide.meta?.scan_time),
										createTableRow(
											'Area of Box Scanned',
											parseFloat(
												(this.props.slide.meta?.scan_area_mm2 * 100 /
													this.props.slide.meta?.scannable_percentage).toFixed(2)
											)
										)] : undefined
									}
									{this.is_superuser ? [
										createTableRow('Morphle ID', this.props.slide.morphle_id),
										createTableRow('CPU Wait Time', this.props.slide.meta?.cpu_waiting_time),
										createTableRow(
											'Scan Time without CPU waiting time',
											((this.props.slide.meta.scan_time_raw -
												this.props.slide.meta.cpu_waiting_time) / 60000).toFixed(2)
												.toString() + '/' + ((this.props.slide.meta.scan_time_raw) / 60000)
												.toFixed(2).toString()
										),
										createTableRow('Strip Hertz', this.props.slide.meta.scan_strip_hertz),
										createTableRow(
											'Estimated Time for 15x15',
											this.props.slide.meta['estimated_time_for_15x15 (225mm2)']
										),
										createTableRow('Scan Area (mm2)', this.props.slide.meta.scan_area_mm2),
										createTableRow('Focus Time', this.props.slide.meta.total_focus_time),
										createTableRow(
											'Translation Time',
											this.props.slide.meta.total_translation_time
										),
										createTableRow(
											'Compensation Time',
											this.props.slide.meta.total_compensation_time
										),
										createTableRow(
											'Scannable Percentage',
											this.props.slide.meta.scannable_percentage
										),
										createTableRow('Total Images', this.props.slide.meta.total_images),
										createTableRow(
											'Swap Count',
											this.props.viewerType === slideViewerType.GAMMA_SLIDE_VIEWER ?
												'See Tile Viewer' :
												this.props.tileViewerSlideMetaData ?
													this.props.tileViewerSlideMetaData.swap_meta_count :
													""
										),
										createTableRow(
											'Swap Percent',
											this.props.viewerType === slideViewerType.GAMMA_SLIDE_VIEWER ?
												'See Tile Viewer' : this.props.tileViewerSlideMetaData !== undefined ?
													this.props.tileViewerSlideMetaData.swap_meta_percent :
													""
										),
										createTableRow('Rescan Time', this.props.slide.meta.rescan_time),
										createTableRow(
											'Rescan Translation Time',
											this.props.slide.meta.rescan_translation_time
										),
										createTableRow('Rescan Focus Time', this.props.slide.meta.rescan_focus_time),
										createTableRow(
											'Rescan Percent',
											this.props.viewerType === slideViewerType.GAMMA_SLIDE_VIEWER ?
												'See Tile Viewer' :
												this.props.tileViewerSlideMetaData ?
													this.props.tileViewerSlideMetaData.rescan_percent :
													""
										),
										createTableRow('Tilt Angle', this.props.slide.meta.tilt_angle),
										createTableRow(
											'Tile Detection Time',
											this.props.slide.meta.tilt_detection_time
										)] : undefined
									}
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				</Grid>
			)];

		let slide_links_card = [
			this.is_superuser ? (
				<Grid container key={"important-links"}>
					<Grid item xs={12}>
						<Divider style={{margin: "10px"}}/>
						<h3 style={{color: "white", textAlign: 'center', marginTop: "10px"}}>Important Links</h3>
					</Grid>
					<Grid container>
						<Grid item xs={6}>
							<a href={getPrefixedUrl('meta/slide_meta.json', this.props.slide)} target={"_blank"}>Slide
								Meta</a>
						</Grid>
						<Grid item xs={6}>
							<a href={getPrefixedUrl('meta/device_settings.json', this.props.slide)}
							   target={"_blank"}>Settings</a>
						</Grid>
						<Grid item xs={6}>
							<a href={getPrefixedUrl('meta/autofocus_metrics.json', this.props.slide)} target={"_blank"}>
								Autofocus Metrics
							</a>
						</Grid>
						<Grid item xs={6}>
							<a href={getPrefixedUrl('meta/scan_metrics.json', this.props.slide)} target={"_blank"}>Scan
								Metrics</a>
						</Grid>
						<Grid item xs={6}>
							<a href={getPrefixedUrl('meta/stage_metrics.json', this.props.slide)} target={"_blank"}>
								Stage Metrics
							</a>
						</Grid>
						<Grid item xs={6}><a onClick={this.redoStitching}>Redo Stitching</a></Grid>
						<Grid item xs={6}>
							<a onClick={() => openInNewTab(getSlideLocalPath(this.props.slide))}>Explorer</a>
						</Grid>
					</Grid>

				</Grid>
			) : undefined
		];

		let slide_description = [
			<Grid container key="slide-description">
				<Grid item xs={12}>
					<Divider style={{margin: "10px"}} />
					<h3 style={{color: "white", textAlign : 'center', marginTop: '10px'}}>Description</h3>
				</Grid>
				<Grid item xs={12}>
					{this.state.edit ?
						<TextField
							multiline
							placeholder="Enter the slide description"
							value={this.state.slide_details}
							rows={3}
							color='secondary'
							margin='normal'
							variant="filled"
							disabled={!hasPermissions([aclPermissions.update_slides_description])}
							onChange={this.changeSlideDetails}
							sx={{my: 1, backgroundColor:'#0b1c3b', justifyContent:'center', width:'100%'}}
						/>
						:
						<div className={this.is_superuser || cookie.loadAll().staff === "true" ? "slide-description-scroll-superuser" : "slide-description-scroll"}>
							{this.state.slide_details === "" || this.state.slide_details === null ?
								"No Description Added" :
								this.state.slide_details
							}
						</div>
					}
				</Grid>
			</Grid>
		];

		return (
			<Grid container spacing={1}>
				<Grid flex={1}>
					<span style={{float: 'right'}}>
						{!this.state.edit ?
							<ModeEditOutlined onClick={this.editFields}/> :
							<SaveOutlined onClick={this.saveFields}/>}
					</span>
				</Grid>

				<Grid container>
					<Grid item xs={5} style={{fontWeight : 700}}>Name</Grid>
					<Grid item xs={7} style={{fontWeight : 300}}>
						{!this.state.edit ?
							<span>{this.state.name}</span> :
							<Input defaultValue={this.state.name} color='secondary' margin='normal' variant="filled"
								size="small" onChange={this.onChangeName} 
								disabled={!hasPermissions([aclPermissions.update_slides_name])}
								sx={{
									my: 1,
									backgroundColor: '#0b1c3b',
									justifyContent: 'center',
									"& .MuiInputBase-input, Mui-disabled": {
										WebkitTextFillColor: "#0ff"
									}
								}}
							/>
						}
					</Grid>
					<Grid item xs={5} style={{fontWeight : 700}}>Scan Type</Grid>
					<Grid item xs={7} style={{fontWeight : 300}}>{this.state.specimen_type}</Grid>
					<Grid item xs={5} style={{fontWeight : 700}}>Tags</Grid>
					<Grid item xs={7} style={{fontWeight : 300}}>
						<EditableTagGroup tag={this.props.slide.tags}
						                  edit={this.state.tagedit}
						                  morphle_id={this.props.slide.morphle_id}
						                  path={this.props.slide.path}
						                  date={this.props.slide.date}
						                  specimen_type={this.props.slide.specimen_type}
						                  name={this.state.name}
						                  case_details={this.state.case_details}
						                  slide_id={this.props.slide.id}
										  archival_status={this.props.slide.archive_status}
						/>
					</Grid>
				</Grid>
				{slide_description}
				{slide_links_card}
				{slide_info_card}
			</Grid>
		);
	}
}

const mapStateToProps = (state) => {
	let loadingState = state.slideLoadingReducer;
	let {activeMapId} = state.gammaStateReducer;
	let {slide} = state.mapsStateReducer[activeMapId] ?? {};
	return {activeMapId, slide, loadingState};
}

export default connect(mapStateToProps)(SlideInfoApp, EditableTagGroup)
